export const benefitItems = [
    {
        title: 'benefits_landing_nl_title_1',
        text: 'benefits_landing_nl_text_1',
        icon: '/icons/stay-anonymous.png',
    },
    {
        title: 'benefits_landing_nl_title_2',
        text: 'benefits_landing_nl_text_2',
        icon: '/icons/global-coverage.png',
    },
    {
        title: 'benefits_landing_nl_title_3',
        text: 'benefits_landing_nl_text_3',
        icon: '/icons/ease-of-use.png',
    },
    {
        title: 'benefits_landing_nl_title_4',
        text: 'benefits_landing_nl_text_4',
        icon: '/icons/legal-compliance.png',
    },
];
